






















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions, mapState, mapGetters } from "vuex";
import QuantityCounter from "@/components/QuantityCounter.vue";
import TinabaAPI from '@/common/TinabaAPI'


const ProductCardInnerProps = Vue.extend({
  inheritAttrs: false,
  computed: {
    ...mapState("global", ["cart"]),
  },
});

@Component({
  components: {
    QuantityCounter,
  },
})
export default class ProductCardInner extends ProductCardInnerProps {
  @Prop({ default: "normal" }) readonly type!: string;
  @Prop({ default: "normal" }) readonly higlightNumber!: string;
  @Prop() readonly lineItem!: MerchantCartItem;
  @Prop({ default: 0 }) readonly quantity!: string;
  @Prop() readonly product!: MerchantProduct;

  SMALL_QUANTITY_LIMIT = 20

  productData: MerchantProduct | null = null;
  variantsData: {} | null = null;
  currentVariantData: {} | null = null;

  get isSoldOut() {

    let v: any = this.variants

    let allVariantsNotAvailable = false;

    if (v && v.length > 0) {
      allVariantsNotAvailable = true;
      for (var i in this.variants) {
        if (v[i].availability > 0) allVariantsNotAvailable = false;
      }
    }

    return (!this.variants && this.product.availability == 0) || (allVariantsNotAvailable)
  }

  get thumbnailImage() {
    return this.productData ? this.productData.thumb : null;
  }

  get variants() {
    return this.variantsData && Object.keys(this.variantsData).length ? this.variantsData : null;
  }

  get currentVariant() {
    return this.currentVariantData;
  }

  set currentVariant(variant) {
    this.currentVariantData = variant;
  }

  handleQuantity($event: any) {
    this.$emit("change", $event);
  }

  handleVariant($event: any) {

    const prevQty = this.quantity;

    this.$emit("selectVariant", $event, this.currentVariant);

    let v: any = this.currentVariant
    if (v.availability < prevQty) {
      this.$emit("change", { quantity: v.availability });
    }
  }

  removeProductFromCart() {
    if (this.lineItem) {
      this.$store.dispatch("global/removeFromCart", this.lineItem.id);
    }
  }

  updateCartQuantity({ quantity }: { quantity: number }) {
    if (quantity === 0) {
      this.removeProductFromCart();
    } else {
      if (this.lineItem) {
        this.$store.dispatch("global/addToCart", {
          product_id: this.lineItem.id,
          quantity,
          prevQuantity: this.lineItem.requestedQuantity,
        });
      }
    }
  }

  async getVariants() {
    if (this.product) {
      try {
        const data = await this.$tinabaAPI.request({
          url: this.product._links.self.href + "/variants",
          method: "GET",
        });
        this.variantsData = data;

        // Preseleziono la prima variante
        let v: any = this.variants;
        if (v && v.length > 0) {
          let i = 0
          while (!this.currentVariantData && i < v.length) {
            if (v[i].availability > 0) {
              this.currentVariantData = v[i];
              this.handleVariant(null);
            }
            i++;
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async created() {
    this.getVariants();

    if (this.lineItem) {
      let id = this.lineItem.parentProduct ? this.lineItem.parentProduct.id : this.lineItem.id;

      const API = new TinabaAPI()
      const productData = await API.$vas.getProduct(this.cart.businessId, this.cart.shopId, id)
      this.productData = productData;
    }
    else if (this.product && this.product.hasCoverPhoto) {
      try {
        const data = await this.$tinabaAPI.request({
          url: this.product._links.self.href,
          method: "GET",
        });
        this.productData = data;
      } catch (error) {
        console.error(error);
      }
    }
    else if (this.product) {
      this.productData = this.product;
    }
  }
}
